<template>
  <div class="table">
    <el-table :data="tableData" @row-click="showInfo" style="width: 100%" :header-cell-style="{
      backgroundColor: '#0E59CB',
      color: '#fff',
    }" :default-sort="{ prop: 'date', order: 'descending' }" ref="singleTable" :highlight-selection-row="false"
      :row-class-name="tableRowClassName">

      <el-table-column prop="source" show-overflow-tooltip sortable label="诉求来源">
        <template slot-scope="scope">
          {{
            scope.row.source == 1 ? "电话"
              : scope.row.source == 2 ? "网络"
                : scope.row.source == 3 ? "用户"
                  : scope.row.source == 4 ? "其它"
                    : scope.row.source == 5 ? "老年服务"
                      : "--"
          }}
        </template>
      </el-table-column>

      <el-table-column prop="title" show-overflow-tooltip sortable label="诉求内容">
        <template slot-scope="scope">
          <div v-html="scope.row.content"></div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" show-overflow-tooltip sortable label="创建日期"></el-table-column>
      <el-table-column prop="propertyName" show-overflow-tooltip sortable label="物业名称"></el-table-column>
      <el-table-column prop="acceptUserName" show-overflow-tooltip sortable label="受理员工"></el-table-column>

      <el-table-column prop="action" show-overflow-tooltip sortable label="处理状态">
        <template slot-scope="scope">
          <div style="height: 50px;line-height: 50px;">
            {{
              scope.row.status == 1 ? "处理中"
                : scope.row.status == 2 ? "已完结"
                  : "--"
            }}
          </div>

          <!-- <el-steps :space="80" active="1" v-if="scope.row.status == 1" finish-status="success">
              <el-step title="处理中"></el-step>
              <el-step title="已处理"></el-step>
            </el-steps>

            <el-steps :space="80" active="2" v-if="scope.row.status == 2" finish-status="success">
              <el-step title="处理中"></el-step>
              <el-step title="转办中"></el-step>
              <el-step title="已处理"></el-step>
            </el-steps> -->
          <!--

            <el-steps :space="80" active="2" v-if="scope.row.action == 3" finish-status="success">
              <el-step title="处理中"></el-step>
              <el-step title="已处理"></el-step>
            </el-steps>
           -->

        </template>
      </el-table-column>
    </el-table>

    <div class="yema">
      <Pagination style="margin-top: 10px" v-show="query.total > 0" :total="query.total" :limit.sync="query.pageSize"
        :page.sync="query.pageNum" round="false" :currentPageSize="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper" @pagination="changePage" />
    </div>

    <el-dialog title="详情" :visible.sync="tsDialog" width="60%" class="tsinfoWrapper">
      <div class="systemTitle" style="width: 50%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;诉求记录
        <div style="margin-top: 10px"></div>
      </div>
      <el-row>
        <el-col :span="24">
          <div class="textBar">
            <span class="label">小区名称：</span>
            <span class="value">{{ tsInfo.houseName }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">事项内容：</span>
            <span class="value" v-html="tsInfo.content"></span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">来源类型：</span>
            <span class="value">{{
              tsInfo.source == 1 ? "电话" :
                tsInfo.source == 2 ? "网络" :
                  tsInfo.source == 3 ? "用户" :
                    tsInfo.source == 4 ? "其它" :
                      tsInfo.source == 5 ? "老年服务" :
                        "--"
            }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">联系人：</span>
            <span class="value">{{ tsInfo.contactName }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">联系电话：</span>
            <span class="value">{{ tsInfo.contactPhone }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">创建时间：</span>
            <span class="value">{{ tsInfo.createTime }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">物业名称：</span>
            <span class="value">{{ tsInfo.propertyName }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">受理员工：</span>
            <span class="value">{{ slygList.nickName }}</span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">处理状态：</span>
            <span class="value">
              {{
                tsInfo.status == 1 ? "处理中" :
                  tsInfo.status == 2 ? "已办结" :
                    "--"
              }}
            </span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="imgwrapper textBar">
            <span class="label">附件：</span>
            <span class="value">
              <div v-for="(item, index) in (tsInfo.fileList || [])" @click="showFile(item.url)">{{ item.name }}</div>
            </span>
          </div>
        </el-col>
      </el-row>

      <div class="systemTitle" style="width: 50%" v-if="tsInfo.evaluate">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业主评价
        <div style="margin-top: 10px"></div>
      </div>
      <el-row v-if="tsInfo.evaluate">
        <el-col :span="24">
          <div class="textBar">
            <span class="label">评价内容：</span>
            <span class="value" v-html="tsInfo.evaluate"></span>
          </div>
        </el-col>

        <el-col :span="24">
          <div class="textBar">
            <span class="label">评价分值：</span>
            <span class="value">{{ tsInfo.evaluateScore }}</span>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="textBar">
            <span class="label">评价时间：</span>
            <span class="value">{{ tsInfo.evaluateTime }}</span>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="textBar">
            <span class="label">评价附件：</span>
            <div class="value">
              <div style="color:#00D1FF;cursor: pointer;" class="files" @click="showFile(its.url)"
                v-for="(its, idx) in (tsInfo.evaluateFileList || [])" :key="idx">
                {{ its.name }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="systemTitle" style="width: 50%" v-if="activities.length > 0">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;处理流程
        <div style="margin-top: 10px"></div>
      </div>

      <el-timeline :reverse="reverse" v-if="activities.length > 0">
        <el-timeline-item v-for="(item, index) in activities" :key="index">

          <div class="dateWrqapper">
            <span>{{ item.createTime }}</span>
          </div>

          <div class="record">

            <template v-if="item.status == 1">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：待受理</div>
                <div>代办单位名称：{{ item.sourceOrgName }}</div>
              </div>
            </template>

            <template v-if="item.status == 2">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：处理中</div>
                <div>接受单位名称：{{ item.sourceOrgName }}</div>
                <div>受理员工：<span v-if="slygList.nickName">{{ slygList.nickName }} ({{ slygList.phonenumber }})</span>
                </div>
              </div>
            </template>

            <template v-if="item.status == 3">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：转办</div>
                <div>转办单位名称：{{ item.sourceOrgName }}</div>
                <div>接受单位名称：{{ item.receiveOrgName }}</div>
                <div>转办意见：{{ item.notes }}</div>
                <div>转办附件：
                  <div style="color:#00D1FF;cursor: pointer;" class="files" @click="showFile(its.url)"
                    v-for="(its, idx) in tsInfo.notesFileList" :key="idx">
                    {{ its.name }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="item.status == 4">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：办结回复</div>
                <div>接受单位名称：{{ item.sourceOrgName }}</div>
                <div>受理员工：<span v-if="slygList.nickName">{{ slygList.nickName }} ({{ slygList.phonenumber }})</span>
                </div>
                <div>处理结果：{{ item.notes }}</div>
                <div>回复结果附件：
                  <div style="color:#00D1FF;cursor: pointer;" class="files" @click="showFile(its.url)"
                    v-for="(its, idx) in tsInfo.notesFileList" :key="idx">
                    {{ its.name }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="item.status == 5">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：退回</div>
                <div>退回单位名称：{{ item.sourceOrgName }}</div>
                <div>接收单位名称：{{ item.receiveOrgName }}</div>
                <div>退回意见：{{ item.notes }}</div>
                <div>退回附件：
                  <div style="color:#00D1FF;cursor: pointer;" class="files" @click="showFile(its.url)"
                    v-for="(its, idx) in tsInfo.notesFileList" :key="idx">
                    {{ its.name }}
                  </div>
                </div>
              </div>
            </template>


            <template v-if="item.status == 6">
              <div class="box">
                <div style="color: #257EEA;">处理步骤状态：已升级联席会议</div>
              </div>
            </template>

          </div>
        </el-timeline-item>
      </el-timeline>



      <div style="margin-top: 20px;"></div>

    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/repair.js";
import wyqyId from "../../config";

export default {
  data() {
    return {
      tableData: [],
      slygList:{},
      tsInfo: {},
      tsDialog: false,
      activities: [],
      reverse: false,
      query: {
        // total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      appealsFile: [],
      timer: null,
    };
  },
  mounted() {
    this.initPage();
    this.timer = setInterval(() => {
      this.initPage();
    }, 5000)
  },
  methods: {
    showFile(url) {
      window.open(url)
    },
    showInfo(row) {

      this.tsDialog = true;

      api.tsInfoNew({ id: row.id }).then(res => {
        if (res.data.code == 200) {
          this.tsInfo = res.data.data || {};
          // let _list1 = [];
          // if (res.data.data && res.data.data.appealsFile) {
          //   _list1 = res.data.data.appealsFile
          // }
          // let _appealsFile = [];
          // _list1.forEach(v => {
          //   _appealsFile.push(v.url)
          // })
          // this.appealsFile = _appealsFile;
          this.activities = res.data.data.stepList || [];
          this.getSlyg(res.data.data.acceptUserId)
        }
      })
    },


    getSlyg(houseId) {
      console.log(houseId, 444)
      api.getSlyg({ id: houseId }).then(res => {
        if (res.data.code == 200) {
          this.slygList = res.data.data || {};
        }
      })
    },


    changePage(val) {
      this.query.pageNum = val;
      this.initPage();
    },
    initPage() {
      let params = {
        ...this.query,
        houseId: "1",
      };
      api.tslistNew(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list || [];

          this.query.total = res.data.data.total;
        }
      });
    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  height: 440px;
}

.yema {
  position: absolute;
  bottom: 20px;
  right: 0;
}

::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}

::v-deep.el-table tbody tr:hover>td {
  background-color: unset !important;
}

::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  height: 20px;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}


::v-deep .el-carousel__container {
  height: 350px;
}

::v-deep .el-dialog {
  width: 800px;
  min-height: 400px;
  background: url("../../assets/images/dialog_bg2.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;

  overflow-y: auto !important;

}

::v-deep .el-dialog__title {
  color: #fff !important;
  font-size: 20px;
  font-weight: 600;
}

::v-deep .el-dialog__header {
  margin: 0 20px;
  border-bottom: 1px solid #338bea;
}

::v-deep .el-form-item__label {
  color: #fff;
}

::v-deep .el-dialog__body {
  color: #fff;
}

::v-deep .el-form-item {
  margin: 0;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}

.value,
.label {
  margin-bottom: 15px;
  font-size: 16px;

  // &.label {
  //   display: inline-block;
  //   width: 100px;

  // }

  &.value {
    color: #338bea;
  }
}

.record {
  color: #fff;
  min-width: 500px;
  max-width: 80%;
  min-height: 30px;
  border-radius: 4px;
  border: 1px solid #4172a5;
  margin: 0 0 0 30px;
  padding: 10px;

  .sss {
    display: flex;
    justify-content: space-between;

    .state {
      padding: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      background: #1763e8;
      border-radius: 3px;
    }
  }



  &>div {
    margin-bottom: 10px;
  }

  .files {
    color: #1763e8;
    cursor: pointer;
    margin-top: 10px;
  }
}

.imgwrapper {
  display: flex;
  align-items: flex-start;
}

.dateWrqapper {
  min-width: 500px;
  max-width: 80%;
  margin: 0 0 0 30px;
  padding: 10px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}

::v-deep .tsinfoWrapper p {
  margin: 0;
  padding: 0;
  color: #338bea !important;
  padding: 0 !important;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  text-indent: 0 !important;

  font-size: 16px !important;
  line-height: 24px !important;
}

::v-deep .dateWrqapper {
  padding: 0 !important;
  margin-bottom: 5px !important;
}



.textBar {
  display: flex;
  // flex-direction: column;
  margin-bottom: 15px;

  .label {
    display: flex;
    width: 80px;
    justify-content: flex-end;
  }

  .value {
    width: 0;
    flex: 1;
  }
}

::v-deep .el-step__icon {
  width: 17px !important;
  height: 17px !important;
}

::v-deep .el-step__title {
  font-size: 14px;
  line-height: 28px;
}

::v-deep .el-step__title.is-process {
  color: #C0C4CC !important;
  font-size: 14px !important;
  font-weight: normal !important;
}

::v-deep .el-table .el-table__cell {
  padding: 3px 0 !important;
}

::v-deep .el-step__icon-inner {
  visibility: hidden !important;
}
</style>
